import NextMail from './components/NextMail'
import style from './assets/scss/style.module.scss'

function App() {
  return (
    <div className={style.container}>
      <NextMail />
    </div>
  );
}

export default App;
